import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DateTime } from 'luxon';
import { ReplaySubject } from 'rxjs';
import { GeneralService } from 'src/app/services/general/general.service';

@Component({
  selector: 'app-chat-list',
  templateUrl: './chat-list.component.html',
  styleUrls: ['./chat-list.component.scss'],
})
export class ChatListComponent implements OnInit {
  @Input() chatSelected: any = null;
  public loading: any = false;
  public subscriptions: any = [];
  public chats: any = [];
  public searchCtrl: FormControl = new FormControl('');
  public filteredChats: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public notReadChatsCount: number = 0;

  constructor(public general: GeneralService) { }

  async ngOnInit() {
    window.addEventListener('app:new-message', this);
    this.filteredChats.next(this.chats.slice());
    this.intializeSubscriptions();
    await this.loadChats();

    const currentChat = localStorage.getItem('current-chat');
    if (currentChat) {
      const chat = JSON.parse(currentChat);

      const chatAlreadyExist = this.chats.find((currentChat: any) => {
        return chat.user_id == currentChat.user_id;
      });
      if (!chatAlreadyExist) {
        this.chats.unshift(chat);
        this.filteredChats.next(this.chats);
      }

      localStorage.removeItem('current-chat');
      window.dispatchEvent(
        new CustomEvent('chat:open', {
          detail: {
            id: Number.parseInt(chat.user_id),
          },
        })
      );
      this.chatSelected = Number.parseInt(chat.user_id);
    }

  }

  ngOnDestroy() {
    window.removeEventListener('app:new-message', this);

    this.subscriptions.forEach((subscription: any) => {
      subscription.unsubscribe();
    });
  }

  intializeSubscriptions() {
    this.subscriptions = [
      this.general.loading$.subscribe((res) => (this.loading = res)),
      this.searchCtrl.valueChanges.pipe().subscribe(() => {
        this.filterChats();
      }),
    ];
  }

  // Handle event Listener
  handleEvent(event: any) {
    switch (event.type) {
      case 'app:new-message':
        this.addNewMessage(event.detail.message);
        break;
    }
  }

  async loadChats() {
    const response = await this.general.httpGet('chat/load-chat-list');
    this.chats = response.data;
    this.notReadChatsCount = 0;
    this.chats.forEach((chat: any) => {
      this.notReadChatsCount += chat.count;
    });
    localStorage.setItem('noReadChats', JSON.stringify(this.notReadChatsCount));

    this.filteredChats.next(this.chats);
  }

  async onChatClicked(chat: any) {
    window.dispatchEvent(
      new CustomEvent('chat:open', {
        detail: {
          id: chat.user_id,
        },
      })
    );
    this.chatSelected = chat.user_id;

    let self = this;
    setTimeout(function () {
      self.loadChats()
    }, 1000);


  }

  filterChats() {
    if (!this.chats) {
      return;
    }
    // get the search keyword
    let search = this.searchCtrl.value;
    if (!search) {
      this.filteredChats.next(this.chats.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredChats.next(
      this.chats.filter(
        (chat: any) =>
          chat.name
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .indexOf(search.normalize('NFD').replace(/[\u0300-\u036f]/g, '')) >
          -1
      )
    );
  }

  addNewMessage(message: any) {
    const currentChat = this.chats.find(
      (chat: any) => chat.user_id === message.from_user.id
    );
    currentChat.last_message = message;
    this.loadChats();

  }
}
